import { fields } from ".";
import { change } from "redux-form";
import ZoneService from "services/zone.service";
import useEffectOnce from "hooks/useEffectOnce";
import MyForm from "components/templates/MyForm";
import { useAppDispatch, useAppSelector } from "redux/hooks";

export default function ChangeDispatchForm() {
  const form = "ChangeDispatchForm";
  const dispatch = useAppDispatch();
  const formData = useAppSelector((state) => state.modal.data);

  useEffectOnce(() => {
    dispatch(change(form, "dispatchAt", formData.dispatchAt));
  });

  const handleSubmit = async (values: any) => {
    let data = { ...values };
    const { slotId } = formData;
    ZoneService.updateDispatchTime(
      {
        slotId,
        validForAllZone: true,
        ...data,
      }
      // navigate
    );
  };

  return (
    <div>
      <h3>Change Dispatch At Slot</h3>
      <MyForm form={form} myFields={fields} onSubmit={handleSubmit} />
    </div>
  );
}
